module.exports = __webpack_public_path__ + "static/media/okta.b73ffedc.svg";